<div #datepickerField tabindex="0"
  [ngClass]="['mp-date-picker', size, customClasses, outlinedColor ?? 'primary', outlinedStyle ?? 'solid']"
  [class.disabled]="disabled"
  [class.readonly]="isReadOnly"
  [class.outlined]="outlined"
  [class.opened]="displayCalendar()"
  [class.invalid]="!isValid()"
  [class.without-value]="!startDateValue">
  <label class="mp-date-picker-label" *ngIf="label && !startDateValue && !startTime"
    [innerHTML]="label | translate"></label>
  <div class="mp-date-picker-wrapper">
    <div (click)="openDatepicker()" (keydown.enter)="openDatepicker()" tabindex="0">
      <i #calendarIcon class="far fa-calendar-day {{outlinedColor ?? 'primary'}}"></i>
    </div>

    <div class="mp-date-inputs" *ngIf="(!startTime && !endTime)">
      <input #dateInput class="mp-date-input" [readonly]="disabled || isReadOnly"
        [(ngModel)]="startDateValue" [ngModelOptions]="{standalone: true}" (blur)="onDateBlur()">
      <ng-container *ngIf="endDateValue">
        <span>-</span>
        <input #dateEndInput class="mp-date-input" [readonly]="disabled"
          [(ngModel)]="endDateValue" [ngModelOptions]="{standalone: true}" (blur)="onEndDateBlur()">
      </ng-container>
    </div>

    <div class="mp-date-plus-hours" *ngIf="(startTime || endTime)">
      <span class="mp-date-value">
        {{ startDateValue }}
        <ng-container *ngIf="endDateValue">
          <span>-</span>
          {{ endDateValue }}
        </ng-container>
      </span>
      <span class="mp-hours-value">{{ timeLabel }}</span>
    </div>
  </div>
</div>

<app-mp-calendar *ngIf="displayCalendar()"
  [anchor]="datepickerFieldElementRef"
  [startDay]="+startDay"
  [endDay]="+endDay"
  [startMonth]="+this.startMonth - 1"
  [endMonth]="+this.endMonth - 1"
  [startYear]="+this.startYear"
  [endYear]="+this.endYear"
  [datePicked]="datePicked.bind(this)"
  [resetSelection]="resetDatepicker.bind(this)"
  [resetStartTime]="resetStartTime.bind(this)"
  [resetEndTime]="resetEndTime.bind(this)"
  [dateIntervalAllowed]="dateIntervalAllowed"
  [timeIntervalAllowed]="timeIntervalAllowed"
  [startTime]="startTime"
  [endTime]="endTime"
  [minDate]="minDate"
  [onlyBusinessDays]="onlyBusinessDays">
</app-mp-calendar>
